import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import './Performance.css'
import TableCourses from './Tables/TableCourses/TableCourses'
import TableTests from './Tables/TableTests/TableTests'
import Radio from '../App/Common/Inputs/Radio/Radio'

import api from '../../Utils/Api'
import { CurrentUserContext } from '../../Contexts/CurrentUserContext'
import { JourneyContext } from '../../Contexts/JourneyContext'
import Calendar from '../Calendar/Calendar'

const Performance = ({}) => {
  const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } =
    useContext(JourneyContext)
  const { token } = useContext(CurrentUserContext)
  const [performanceData, setPerformanceData] = useState(undefined)
  const [isCoursesOpened, setIsCoursesOpened] = useState(false)
  const [isThemeOpened, setIsThemeOpened] = useState(false)
  const [isLessonsOpened, setIsLessonsOpened] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState(undefined)
  const [tests, setTests] = useState(undefined)
  const [themeSiblings, setThemeSiblings] = useState(undefined)
  const [lessonSiblings, setLessonSiblings] = useState(undefined)
  const [isCourseChecked, setIsCourseChecked] = useState(false)
  const [isThemeChecked, setIsThemeChecked] = useState(false)
  const [isLessonChecked, setIsLessonChecked] = useState(false)
  const [checkedId, setCheckedId] = useState({})

  let params = useParams()

  useEffect(() => {
    setCurrentPlace({ title: 'Актуальные курсы' })

    api
      .getPerformance(token)
      .then((res) => {
        //  console.log(res)
        setPerformanceData(res)
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])
  useEffect(() => {
    if (params.id) {
      Promise.all([
        api.getPerformanceSpecial(token, 'course', params.id),
        api.getFilterInfo(token, 'courses', params.id),
      ])
        .then(([statData, filterData]) => {
          // console.log(statData)
          //console.log(filterData)
          setTests(statData)
          setThemeSiblings(filterData.topics)
          setLessonSiblings(filterData.lessons)
          setIsCourseChecked(true)
          setCheckedId({ model: 'course', id: params.id })
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }, [params])

  const checkCourse = (id) => {
    Promise.all([
      api.getPerformanceSpecial(token, 'course', id),
      api.getFilterInfo(token, 'courses', id),
    ])
      .then(([statData, filterData]) => {
        setTests(statData)
        setThemeSiblings(filterData.topics)
        setLessonSiblings(filterData.lessons)
        setIsCourseChecked(true)
      })
      .catch((e) => {
        console.log(e)
      })
  }
  const filterData = (id, model) => {
    api
      .getPerformanceSpecial(token, model, id)
      .then((res) => {
        // console.log(res)
        setTests(res)
      })
      .catch((e) => {
        console.log(e)
      })
  }
  const refreshSiblings = (id) => {
    api
      .getFilterInfo(token, 'topics', id)
      .then((filterData) => {
        //console.log(filterData)
        setLessonSiblings(filterData)
      })
      .catch((e) => {
        console.log(e)
      })
  }
  const cleanFilter = (id, model) => {
    // console.log('i m trying to clean filter')

    api
      .getPerformanceSpecial(token, model, id)
      .then((res) => {
        // console.log(res)
        setTests(res)
        setCheckedId({ model: model, id: id })
      })
      .catch((e) => {
        console.log(e)
      })
  }
  const cleanCourse = () => {
    //console.log('i m trying to clean course')
    api
      .getPerformance(token)
      .then((res) => {
        //console.log(res)
        setPerformanceData(res)
        setTests(undefined)
        setLessonSiblings(undefined)
        setThemeSiblings(undefined)
        setIsCourseChecked(false)
        setIsCoursesOpened(false)
        setIsLessonChecked(false)
        setIsThemeChecked(false)
        setCheckedId({ id: undefined, model: undefined })
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const sortTable = (orderBy, orderType) => {
    //console.log('sorting order by', orderBy, 'order type', orderType)
    if (isCourseChecked) {
      api
        .getPerformanceSpecialSorted(
          token,
          checkedId.model,
          checkedId.id,
          orderBy,
          orderType
        )
        .then((res) => {
          // console.log(res)
          setTests(res)
        })
        .catch((e) => {
          console.log(e)
        })
    } else {
      api
        .getPerformanceSorted(token, orderBy, orderType)
        .then((res) => {
          // console.log(res)
          setPerformanceData(res)
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
  const onChangeCourseFilter = (id) => {
    checkCourse(id)
    setCheckedId({ model: 'courses', id: id })
  }
  const onChangeThemeFilter = (id) => {
    filterData(id, 'topic')
    refreshSiblings(id)
    setIsThemeChecked(true)
    setCheckedId({ model: 'topic', id: id })
  }
  const onChangeLessonFilter = (id) => {
    filterData(id, 'lesson')
    setIsLessonChecked(true)
    setCheckedId({ model: 'lesson', id: id })
  }
  const onCleanThemeFilter = () => {
    setIsThemeOpened(false)
    cleanFilter(themeSiblings[0].parent_id, 'courses')
    setIsThemeChecked(false)
  }
  const onCleanLessonFilter = (id) => {
    setIsLessonsOpened(false)
    cleanFilter(lessonSiblings.id, 'topic')
    setIsLessonChecked(false)
  }
  // console.log(themeSiblings)
  // console.log(lessonSiblings)

  const defaultData = [
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
    {
      name: 'Русский язык',
      progress: '12/20',
      average: '95%',
      group: '95%',
    },
  ]
  const defaultMetrics = [
    {
      name: 'title',
      orderType: 'asc',
    },
    {
      name: 'avg',
      orderType: 'asc',
    },
  ]
  const [sortingData, setSortingData] = useState(defaultMetrics)
  const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('')
  const handleOpenTab = (title) => {
    if (title === 'Все курсы') {
      setTab(false)
      setTitle('_courses')
    } else if (title === 'Календарь') {
      setTab(true)
      setTitle('_calendar')
    } else if (title === 'Архив') {
      setTab(true)
      setTitle('_archive')
    }
  }
  return (
    performanceData && (
      <div className="performance__container">
        <div className="tab__wrap">
          <div
            className={
              'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')
            }
            onClick={() => handleOpenTab('Все курсы')}
          >
            Актуальные курсы
          </div>
          <div
            className={
              'tab__btn' + (titleTag ? titleTag === '_archive' : 'false')
            }
            onClick={() => handleOpenTab('Архив')}
          >
            Архив
          </div>
          {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
        </div>
        <div className="openedBlock__container">
          {titleTag === '_calendar' && (
            <div className="courses__calendar">
              <Calendar></Calendar>
            </div>
          )}
          {titleTag === '_archive' && (
            <div className="courses__calendar">
              <div className="archive__wrapper">
                <div className="archive__container">
                  <p>В данный момент нет архивированных курсов</p>
                </div>
              </div>
            </div>
          )}
          {(!tab || titleTag === '_courses') && (
            <>
              {' '}
              <div className="performance__infoContainer">
                {/* <div className='performance__navTree'>
                    <Link to={'/'}> <div >Главная</div> </Link>
                    <div className='current'>Успеваемость</div>
                </div> */}
                <div className="tableCourses__top">
                  <div
                    className={`tableCourses__names tableTests__result`}
                    onClick={() => {
                      sortTable(sortingData[0].name, sortingData[0].orderType)
                      sortingData[0] = {
                        ...sortingData[0],
                        orderType:
                          sortingData[0].orderType === 'asc' ? 'desc' : 'asc',
                      }
                    }}
                  >
                    Курсы
                    <div
                      className={`sortable ${
                        sortingData[0].orderType === 'asc' ? 'rotated' : ''
                      }`}
                    ></div>
                  </div>
                  <div className="tableCourses__results">
                    <div>Пройдено тестов</div>
                    <div
                      className={`tableTests__result`}
                      onClick={() => {
                        sortTable(sortingData[1].name, sortingData[1].orderType)
                        sortingData[1] = {
                          ...sortingData[1],
                          orderType:
                            sortingData[1].orderType === 'asc' ? 'desc' : 'asc',
                        }
                      }}
                    >
                      Средний результат
                      <div
                        className={`sortable ${
                          sortingData[1].orderType === 'asc' ? 'rotated' : ''
                        }`}
                      ></div>
                    </div>
                    <div>Результат группы</div>
                  </div>
                </div>
              </div>
              {tests ? (
                <TableTests data={tests} sortTable={sortTable} />
              ) : (
                <TableCourses data={performanceData} sortTable={sortTable} />
              )}
            </>
          )}
        </div>
      </div>
    )
  )
}
export default Performance
